/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DataLineChart_data$ref: FragmentReference;
declare export opaque type DataLineChart_data$fragmentType: DataLineChart_data$ref;
export type DataLineChart_data = {|
  +wellbeingChart: ?$ReadOnlyArray<?{|
    +mean: ?number,
    +date: ?any,
  |}>,
  +$refType: DataLineChart_data$ref,
|};
export type DataLineChart_data$data = DataLineChart_data;
export type DataLineChart_data$key = {
  +$data?: DataLineChart_data$data,
  +$fragmentRefs: DataLineChart_data$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "DataLineChart_data",
  "type": "RelayQuery",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "wellbeingChart",
      "storageKey": null,
      "args": null,
      "concreteType": "ChartPoint",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "mean",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "date",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'e8873569845d3a95516c533606f06024';
module.exports = node;
